import React from "react";
import {
    Button,
    convertInputFormToObject,
    SelectField
} from "../../../../Components/Inputs";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {LinkButton} from "../../../../Components/Link";
import {locations} from "../../../../Utilities/Location";
import {isObjectNullOrEmpty} from "../../../../Utilities/Types/objectUtilities";
import {isBraillerQueueFormValid} from "./braillerQueueUtility";
import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface BraillerQueueFormProps {
    queueForm: Record<string, any>;
    shippingLocations: ListItem[];
    students: ListItem[];
    handleAssignQueueItems: (data: Record<string, unknown>) => void;
    setWarnings: (warnings: string[]) => void;
}

export const BraillerQueueForm = ({
                                      queueForm,
                                      shippingLocations,
                                      students,
                                      handleAssignQueueItems,
                                      setWarnings,
                                  }: BraillerQueueFormProps) => {

    const handleClickSubmit = () => {
        if (!queueForm) {
            setWarnings(["Form is not properly initialized. Please refresh the page."]);
            return;
        }

        if (!isBraillerQueueFormValid(queueForm)) {
            setWarnings(["Missing required items.  Please review your responses and try submitting again."]);
            return;
        }

        const braillerModel = convertInputFormToObject(queueForm);
        handleAssignQueueItems(braillerModel);
    };

    if (!queueForm) {
        return null;
    }

    if (isObjectNullOrEmpty(shippingLocations)) {
        return null;
    }

    return <>
        <GridContainer hasMarginX>
            <SelectField
                {...queueForm.shippingLocationId}
                defaultOption={`Select Shipping Location`}
                medium_columns={gridConstants.column.SIX}
                large_columns={gridConstants.column.SIX}
                label={`Location`}
                options={shippingLocations}
            />

            <SelectField
                {...queueForm.studentId}
                defaultOption={`Select Student`}
                medium_columns={gridConstants.column.SIX}
                large_columns={gridConstants.column.SIX}
                label={`Student`}
                options={students}
            />

            <GridCell large_offset={gridConstants.column.THREE} medium_columns={gridConstants.column.SIX}
                      large_columns={gridConstants.column.THREE}>
                <LinkButton {...locations.SHIPPING_LOCATION_ADD.link} isExpanded/>
            </GridCell>
            <GridCell medium_columns={gridConstants.column.SIX} large_columns={gridConstants.column.SIX}>
                <Button
                    isPrimary
                    label={`Submit`}
                    name={`btnSubmit`}
                    onClick={handleClickSubmit}
                />
            </GridCell>
        </GridContainer>
        <br/>
        <br/>
    </>;
};
